<template>
    <header class="header">
        <div class="container">
            <div class="headerWrapper">
                <div class="header__left">
                    <div class="header__left--menu-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <!-- logo -->
                    <div class="header__left--logo">
                        <a href="">
                            <img
                                :src="logo.icon"
                                alt="buytech-logo"
                                class="img-fluid hide-on-md"
                            />
                            <img
                                :src="logo"
                                alt="buytech-logo"
                                class="img-fluid d-none show-on-md"
                            />
                        </a>
                    </div>
                    <!-- for responsive languege dropdown  -->
                    <div class="dropdown d-none show-on-md">
                        <button class="dropdown-toggle" data-toggle="dropdown">
                            <img src="/assets/images/svg/flag.svg" alt="" />
                        </button>
                        <div class="dropdown-menu">
                            <a
                                href="javascript:void(0)"
                                @click="changeLocale(otherLocale)"
                            >
                                {{ otherLangText }}
                            </a>
                            <a class="dropdown-item" href="#">Kurdî</a>
                        </div>
                    </div>
                </div>
                <!-- nav -->
                <div class="header__right">
                    <nav>
                        <ul>
                            <!--                            <li>-->
                            <!--                                <a href="javascript:void(0)">-->
                            <!--                                    {{ $t('general.Contact Us') }}-->
                            <!--                                </a>-->
                            <!--                            </li>-->
                            <li class="login">
                                <router-link :to="`/${$i18n.locale}/login`">
                                    {{ $t('auth.Login') }}
                                </router-link>
                            </li>
                            <li class="language hide-on-md">
                                <a
                                    href="javascript:void(0)"
                                    @click="changeLocale(otherLocale)"
                                >
                                    {{ otherLangText }}
                                </a>
                            </li>
                            <!--                            <li class="hide-on-md">-->
                            <!--                                <a href="#">Kurdî</a>-->
                            <!--                            </li>-->
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import cookieHandler from '@/common/cookies-service'

export default {
    name: 'Header',
    props: {
        logo: Object,
    },
    computed: {
        otherLocale() {
            return this.$i18n.locale === 'en' ? 'ar' : 'en'
        },
        otherLangText() {
            return this.$i18n.locale === 'ar' ? 'English' : 'العربية'
        },
    },
    methods: {
        changeLocale(locale) {
            this.$i18n.locale = locale
            cookieHandler.setCookie('locale', this.$i18n.locale)
            this.$router.push({
                params: { lang: locale },
                name: this.$route.name,
            })
            window.location.reload()
        },
    },
}
</script>
<style lang="scss" scoped>
[lang='ar'] {
    .header nav ul li:not(:last-child) {
        margin-right: unset !important;
        margin-left: 2.5rem !important;
    }
    .header nav ul li.login a {
        font-family: 'Almarai', sans-serif !important;
    }
}
</style>
